import React from "react";
import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Dash from "../../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../../components/RowValue/RowBody";

function KoeffizientNachGudehus({ koeffizientNachGudehus = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterSoil.bucklingCoefficientGudenhaus")}</p>}
      indicesValue={
        <span>
          k<sub>y</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(koeffizientNachGudehus)}</span>}
      unitValue={<Dash />}
    />
  );
}

export default KoeffizientNachGudehus;
